import React from 'react';
import InnerLabel from '../InnerLabel';

export type PayPalAdvancedCardProcessingFieldProps = {
  fieldName: string;
  fieldLabel: string;
  hasError: boolean;
  showPlaceholder?: boolean;
};

export const PayPalAdvancedCardProcessingFieldTestId =
  'PayPalAdvancedCardProcessingField-input';

const PayPalAdvancedCardProcessingField: React.FC<
  PayPalAdvancedCardProcessingFieldProps
> = ({
  fieldName,
  fieldLabel,
  hasError,
}: PayPalAdvancedCardProcessingFieldProps) => {
  const labelClasses = `absolute`;
  return (
    <div className="mx-2">
      <InnerLabel
        inputName={fieldName}
        hasErrors={hasError}
        className={labelClasses}
      >
        {fieldLabel}
      </InnerLabel>
      <div
        id={fieldName}
        data-testid={PayPalAdvancedCardProcessingFieldTestId}
        className={`w-full h-12 border-1-half rounded border-transparent outline-none checkout-panel-form-input ${
          hasError ? 'input-error-border' : ''
        }`}
      />
    </div>
  );
};

export default PayPalAdvancedCardProcessingField;
